import React, { createRef, useState, useEffect } from 'react';
import Swipe from 'react-easy-swipe';
import useTimeout from '../../hooks/useTimeout';

import styles from './styles.scss';

const CareersJobMobileList = props => {
  const { jobLocations, breakpoint, setJobLocation, activeID, active, clicked } = props;

  const timeout = useTimeout();
  const [currentIndex, setCurrentIndex] = useState(jobLocations.length);
  const [prevIndex, setPrevIndex] = useState(jobLocations.length - 1);
  const [nextIndex, setNextIndex] = useState(jobLocations.length + 1);
  const [newLocation] = useState(jobLocations);
  const [newLocationCopy] = useState([...jobLocations, ...jobLocations, ...jobLocations]);
  const [lastIndex, setLastIndex] = useState(0);
  const [initLoad, setInitLoad] = useState(true);
  const [activeWidths, setActiveWidths] = useState([]);
  const [inactiveWidths, setInactiveWidths] = useState([]);

  const mobileListRefWrapper = createRef();
  const mobileListRefWrapper2 = createRef();
  const careersJobMobile = createRef();
  const mobileListRef = [];
  const mobileListRefActive = [];
  let currentX = 0;
  const location = breakpoint === 'mobile' ? [...newLocationCopy] : [...newLocation];

  // componentDidMount
  useEffect(() => {
    // set an array for all the inactive and active width of each location
    const arr1 = mobileListRef.map(list => list.clientWidth);
    const arr2 = mobileListRefActive.map(list => list.clientWidth);
    setActiveWidths(arr2);
    setInactiveWidths(arr1);

    if (breakpoint === 'mobile' || breakpoint === 'tablet') {
      setInitLoad(false);

      initialTranslate(updateCareersArrayLength());
      careersJobMobile.current.classList.add(`${styles.CareersJobMobileList__container}--fade-in`);
      mobileListRefWrapper2.current.style.display = 'none';
    }
  }, []);

  // set initial translate on breakpoint change
  useEffect(() => {
    initialTranslate(updateCareersArrayLength());
    setJobLocation(newLocation[0], false);
  }, [breakpoint]);

  useEffect(() => {
    if (breakpoint === 'mobile') {
      const activeeID = newLocationCopy.indexOf(active) + newLocation.length;

      if (!clicked) {
        // if the user scrolls to the page, translate to active location
        mobileListRefWrapper.current.classList.remove(
          `${styles.CareersJobMobileList__mobile}--swipe`
        );
        translateLocation(activeeID, -1, updateCareersArrayLength());
      }
    }
  }, [clicked, active]);

  useEffect(() => {
    timeout(() => {
      if (lastIndex === -1) {
        initialTranslate(updateCareersArrayLength());
      }

      // set a width for careers navigation list if there are less than 3 jobs
      if (
        breakpoint === 'mobile' &&
        mobileListRef !== null &&
        mobileListRef[currentIndex] &&
        mobileListRef[nextIndex]
      ) {
        if (newLocation.length < 3) {
          const careersWidth =
            mobileListRef[currentIndex].offsetWidth + mobileListRef[nextIndex].offsetWidth;
          careersJobMobile.current.style.width = `${careersWidth}px`;
        } else {
          const careersWidth =
            mobileListRef[currentIndex].offsetWidth +
            mobileListRef[nextIndex].offsetWidth +
            (mobileListRef[nextIndex + 1] ? mobileListRef[nextIndex + 1].offsetWidth : 0);
          careersJobMobile.current.style.width = `${careersWidth}px`;
        }
      }
    }, 350);
  }, [breakpoint, lastIndex]);

  // Translates to the initial location
  function initialTranslate(activeWidth) {
    if (breakpoint === 'mobile') {
      const initialIndex = newLocation.length + activeID;
      setActiveLink(initialIndex, false);

      setCurrentIndex(newLocation.length);
      setPrevIndex(newLocation.length - 1);
      setNextIndex(newLocation.length + 1);
      setLastIndex(0);

      const sliced = activeWidth.slice(0, newLocation.length);
      const initLocation = sliced.reduce((acc, i) => acc + i, 0);

      currentX = -initLocation;

      if (mobileListRefWrapper.current) {
        mobileListRefWrapper.current.classList.remove(
          `${styles.CareersJobMobileList__mobile}--swipe`
        );
        mobileListRefWrapper.current.style.transform = `translateX(${currentX}px)`;
      }
    } else if (mobileListRefWrapper.current) {
      mobileListRefWrapper.current.style.transform = 'translateX(0px)';
    }
  }

  // translates to active location
  function translateLocation(index, swipe, activeWidth) {
    if (swipe === 0) {
      setActiveLink(nextIndex, true);
    }
    if (swipe === 1) {
      setActiveLink(prevIndex, true);
    }

    setCurrentIndex(index);
    setPrevIndex(index - 1 < 0 ? 0 : index - 1);
    setNextIndex(index + 1 > newLocationCopy.length ? newLocationCopy.length - 1 : index + 1);
    setLastIndex(
      index === newLocationCopy.length - newLocation.length * 2 ||
        index === newLocationCopy.length - newLocation.length
        ? -1
        : 0
    );

    const sliced = activeWidth.slice(0, index);

    const initLocation = sliced.reduce((acc, i) => acc + i, 0);
    currentX = -initLocation;
    mobileListRefWrapper.current.style.transform = `translateX(${currentX}px)`;
  }

  // set the active link to the active location. calls setJobLocation function
  function setActiveLink(index, boolean) {
    if (mobileListRef[index]) {
      const selectBtn = mobileListRef[index].querySelector('button');
      const getBtnLocation = selectBtn.innerText;
      setJobLocation(getBtnLocation, boolean);
    }
  }

  // returns new array changing the value of the active location to the active length.
  function updateCareersArrayLength(activeLocation) {
    const aLoc = activeLocation || active;
    const a = newLocation.indexOf(aLoc);
    const activeLength = activeWidths[a];
    const newArray = [...inactiveWidths];

    newLocationCopy.map((loc, i) => {
      if (loc === aLoc) {
        newArray[i] = activeLength;
      }
      return newArray;
    });

    return newArray;
  }

  function onSwipeStart() {
    if (breakpoint !== 'mobile') return;

    mobileListRefWrapper.current.classList.remove(`${styles.CareersJobMobileList__mobile}--swipe`);
  }

  function onSwipeEnd() {
    if (breakpoint !== 'mobile') return;

    mobileListRefWrapper.current.classList.add(`${styles.CareersJobMobileList__mobile}--swipe`);
  }

  function onSwipeLeft() {
    if (breakpoint !== 'mobile') return;

    translateLocation(nextIndex, 0, updateCareersArrayLength(newLocationCopy[nextIndex]));
  }

  function onSwipeRight() {
    if (breakpoint !== 'mobile') return;
    translateLocation(prevIndex, 1, updateCareersArrayLength(newLocationCopy[prevIndex]));
  }

  function clickToLocation(i) {
    if (breakpoint === 'mobile') {
      setActiveLink(i, true);
      translateLocation(i, 2, updateCareersArrayLength(newLocationCopy[i]));
    } else {
      setJobLocation(jobLocations[i], true);
    }
  }

  return (
    <Swipe
      className={styles.CareersJobMobileList}
      onSwipeStart={onSwipeStart}
      onSwipeEnd={onSwipeEnd}
      onSwipeLeft={onSwipeLeft}
      onSwipeRight={onSwipeRight}
      allowMouseEvents={true}>
      <div ref={careersJobMobile} className={styles.CareersJobMobileList__container}>
        <ul className={styles.CareersJobMobileList__mobile} ref={mobileListRefWrapper}>
          {location &&
            location.map((location, i) => (
              <li
                key={i}
                className={`${styles.CareersJobMobileList__mobile__item} ${
                  styles.CareersJobMobileList__mobile__item
                }${active === location && !initLoad ? '--active-link' : ''}`}
                ref={_mobileListRef => (mobileListRef[i] = _mobileListRef)}>
                <button
                  type="button"
                  onClick={() => clickToLocation(i)}
                  className={styles.locationButton}>
                  {location}
                </button>
              </li>
            ))}
        </ul>
      </div>
      <ul className={styles.CareersJobMobileList__invisible} ref={mobileListRefWrapper2}>
        {jobLocations &&
          jobLocations.map((location, i) => (
            <li
              key={i}
              className={`${styles.CareersJobMobileList__invisible__list} ${styles.CareersJobMobileList__invisible__list}--active-link`}
              ref={_mobileListRefActive => (mobileListRefActive[i] = _mobileListRefActive)}>
              {location}
            </li>
          ))}
      </ul>
    </Swipe>
  );
};

export default CareersJobMobileList;
